/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { config, fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Tr } from '../../../../_metronic/i18n/Tr'
import JoditEditor from 'jodit-react'
import PriceInput from '../../components/PriceInput'

const ViewReferralSettings = () => {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()

  const enPrecautionRef = useRef(null) as any

  const [error, setError] = useState(Object)

  // refer code states
  const [accommmodationReferralPrice, setAccommmodationReferralPrice] = useState("")
  const [spaceRentalsReferralPrice, setSpaceRentalsReferralPrice] = useState("")
  const [tourPackagesReferralPrice, setTourPackagesReferralPrice] = useState("")
  const [carRentalsReferralPrice, setCarRentalsReferralPrice] = useState("")
  const [cafeAndRestaurantsReferralPrice, setCafeAndRestaurantsReferralPrice] = useState("")
  const [referralTermsAndPolicy, setReferralTermsAndPolicy] = useState("")
  const [referralLoading, setReferralLoading] = useState(false)

  const referralDataApiCall = async () => {
    var res = await fetchData('admin/viewreferralpriceandpolicy', {});

    if (res.status == '200') {
      
      res.data.forEach((item: any) => {
        switch (item.key) {
          case 'accommmodationReferralPrice':
            setAccommmodationReferralPrice(item.value);
            break;
          case 'spaceRentalsReferralPrice':
            setSpaceRentalsReferralPrice(item.value);
            break;
          case 'tourPackagesReferralPrice':
            setTourPackagesReferralPrice(item.value);
            break;
          case 'carRentalsReferralPrice':
            setCarRentalsReferralPrice(item.value);
            break;
          case "cafeAndRestaurantsReferralPrice":
            setCafeAndRestaurantsReferralPrice(item.value);
            break;
          case 'referralTermsAndPolicy':
            setReferralTermsAndPolicy(item.value);
            break;
          default:
            break;
        }
      });
    } else {
      toasterrormsg(res.message);
    }
  };

  useEffect(() => {
    referralDataApiCall()
  }, [])

  const removeError2 = (err: any) => {
    var tmp = Array.isArray(error) ? [...error] : [{}]
    if (!tmp[0]) tmp[0] = {}
    tmp[0][err] = ''
    setError(tmp)
  }

  const referralValidate = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}]

    // ✅ Accommodation Referral Price
    if (!accommmodationReferralPrice || isNaN(Number(accommmodationReferralPrice)) || Number(accommmodationReferralPrice) <= 0) {
      errorTmp[0].accommmodationReferralPrice = t('Accommodation Price is required and must be greater than 0')
      err = 1
    } else if (accommmodationReferralPrice.toString().length > 10) {
      errorTmp[0].accommmodationReferralPrice = t('Accommodation Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Space Rentals Referral Price
    if (!spaceRentalsReferralPrice || isNaN(Number(spaceRentalsReferralPrice)) || Number(spaceRentalsReferralPrice) <= 0) {
      errorTmp[0].spaceRentalsReferralPrice = t('Space Rentals Price is required and must be greater than 0')
      err = 1
    } else if (spaceRentalsReferralPrice.toString().length > 10) {
      errorTmp[0].spaceRentalsReferralPrice = t('Space Rentals Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Tour Packages Referral Price
    if (!tourPackagesReferralPrice || isNaN(Number(tourPackagesReferralPrice)) || Number(tourPackagesReferralPrice) <= 0) {
      errorTmp[0].tourPackagesReferralPrice = t('Tour Packages Price is required and must be greater than 0')
      err = 1
    } else if (tourPackagesReferralPrice.toString().length > 10) {
      errorTmp[0].tourPackagesReferralPrice = t('Tour Packages Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Car Rentals Referral Price
    if (!carRentalsReferralPrice || isNaN(Number(carRentalsReferralPrice)) || Number(carRentalsReferralPrice) <= 0) {
      errorTmp[0].carRentalsReferralPrice = t('Car Rentals Price is required and must be greater than 0')
      err = 1
    } else if (carRentalsReferralPrice.toString().length > 10) {
      errorTmp[0].carRentalsReferralPrice = t('Car Rentals Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Café & Restaurants Referral Price
    if (!cafeAndRestaurantsReferralPrice || isNaN(Number(cafeAndRestaurantsReferralPrice)) || Number(cafeAndRestaurantsReferralPrice) <= 0) {
      errorTmp[0].cafeAndRestaurantsReferralPrice = t('Cafe Restaurant Price is required and must be greater than 0')
      err = 1
    } else if (cafeAndRestaurantsReferralPrice.toString().length > 10) {
      errorTmp[0].cafeAndRestaurantsReferralPrice = t('Cafe Restaurant Price must not exceed 10 characters')
      err = 1
    }

    // ✅ Referral Terms & Policy (Text Editor)
    if (!referralTermsAndPolicy || referralTermsAndPolicy.trim() === '') {
      errorTmp[0].referralTermsAndPolicy = t('Referral Terms & Policy is required')
      err = 1
    }

    setError(errorTmp)

    if (err === 0) {
      saveReferral()
    }
  }

  const saveReferral = async () => {
    setReferralLoading(true)
    const param = {
      accommmodationReferralPrice: accommmodationReferralPrice,
      spaceRentalsReferralPrice: spaceRentalsReferralPrice,
      tourPackagesReferralPrice: tourPackagesReferralPrice,
      carRentalsReferralPrice: carRentalsReferralPrice,
      cafeAndRestaurantsReferralPrice: cafeAndRestaurantsReferralPrice,
      referralTermsAndPolicy: referralTermsAndPolicy
    }
    var res = await fetchData('admin/savereferralpriceandpolicy', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      referralDataApiCall()
      setReferralLoading(false)
    } else {
      toasterrormsg(res.message)
      setReferralLoading(false)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | View Referral Settings'
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Referral Settings')}</PageTitle>

      <div className='row justify-content-center'>
        <div className='col-lg-12 col-md-12 mb-4'>
          <div className='card p-5 h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Referral Pricing')}</h3>
              </div>
            </div>

            <div className='card-body p-9 row'>
              <div className='col-lg-5'>
                <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                  <label className='fw-bold text-muted'>{t('Accommodation Referral Price')}</label>
                  <div className='d-flex align-items-center'>
                    <PriceInput
                      placeholder='Enter Price'
                      inputClass='form-control form-control w-75'
                      value={accommmodationReferralPrice}
                      onChange={(event: any) => {
                        setAccommmodationReferralPrice(event.target.value)
                        removeError2('accommmodationReferralPrice')
                      }}
                    />


                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].accommmodationReferralPrice ? error[0].accommmodationReferralPrice : ''}
                  </label>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                  <label className='fw-bold text-muted'>{t('Space Rental Referral Price')}</label>
                  <div className='d-flex align-items-center'>
                    <PriceInput
                      placeholder='Enter Price'
                      inputClass='form-control form-control w-75'
                      value={spaceRentalsReferralPrice}
                      onChange={(value: any) => {
                        setSpaceRentalsReferralPrice(value)
                        removeError2('spaceRentalsReferralPrice')
                      }}
                    />

                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].spaceRentalsReferralPrice ? error[0].spaceRentalsReferralPrice : ''}
                  </label>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                  <label className='fw-bold text-muted'>{t('Tour Package Referral Price')}</label>
                  <div className='d-flex align-items-center'>
                    <PriceInput
                      placeholder='Enter Price'
                      inputClass='form-control form-control w-75'
                      value={tourPackagesReferralPrice}
                      onChange={(value: any) => {
                        setTourPackagesReferralPrice(value)
                        removeError2('tourPackagesReferralPrice')
                      }}
                    />

                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].tourPackagesReferralPrice ? error[0].tourPackagesReferralPrice : ''}
                  </label>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                  <label className='fw-bold text-muted'>{t('Car Rental Referral Price')}</label>
                  <div className='d-flex align-items-center'>
                     <PriceInput
                     
                      placeholder='Enter Price'
                      inputClass='form-control form-control w-75'
                      value={carRentalsReferralPrice}
                      onChange={(value: any) => {
                        setCarRentalsReferralPrice(value)
                        removeError2('carRentalsReferralPrice')
                      }}
                    />
                   
                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].carRentalsReferralPrice ? error[0].carRentalsReferralPrice : ''}
                  </label>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 mb-4'>
                  <label className='fw-bold text-muted'>{t('Cafe & Restaurant Referral Price')}</label>
                  <div className='d-flex align-items-center'>
                        <PriceInput
                      placeholder='Enter Price'
                      inputClass='form-control form-control w-75'
                      value={cafeAndRestaurantsReferralPrice}
                      onChange={(value: any) => {                        
                        setCafeAndRestaurantsReferralPrice(value)
                        removeError2('cafeAndRestaurantsReferralPrice')
                      }}
                    />
                    
                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].cafeAndRestaurantsReferralPrice ? error[0].cafeAndRestaurantsReferralPrice : ''}
                  </label>
                </div>
              </div>

              <div className='col-lg-7'>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                  <label className='fw-bold text-muted'>{t('Referral Terms & Policy')}</label>
                  <div className='d-flex align-items-center'>
                    <JoditEditor
                      ref={enPrecautionRef}
                      config={config(400)}
                      className='form-control form-control w-100'
                      value={referralTermsAndPolicy}
                      onBlur={(newContent: any) => {
                        setReferralTermsAndPolicy(newContent)
                        removeError2('referralTermsAndPolicy')
                      }}
                    />
                  </div>
                  <label className='text-danger'>
                    {error && error[0] && error[0].referralTermsAndPolicy ? error[0].referralTermsAndPolicy : ''}
                  </label>
                </div>
              </div>

              {menuIdEdit ? (
                <div className="d-flex justify-content-start mt-4">
                  <button
                    className="btn btn-success"
                    disabled={referralLoading}
                    onClick={() => {
                      referralValidate()
                    }}
                  >
                    {!referralLoading && t('Save')}
                    {referralLoading && (
                      <span className="indicator-progress d-flex align-items-center">
                        {t('Please wait...')}
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { ViewReferralSettings }